import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TransactionsResponse } from "reduxStore/dataTypes";

interface TransactionsState {
  transactions: TransactionsResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: TransactionsState = {
  transactions: null,
  loading: false,
  error: null,
};

const transactionsSlice = createSlice({
  name: "transactions",
  initialState,
  reducers: {
    transactionsRequest(state) {
      state.loading = true;
      state.error = null;
    },
    transactionsSuccess(state, action: PayloadAction<TransactionsResponse>) {
      state.loading = false;
      state.transactions = action.payload;
    },
    transactionsFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { transactionsRequest, transactionsSuccess, transactionsFailure } =
  transactionsSlice.actions;
export default transactionsSlice.reducer;
